import { OPEN_DROPDOWN, OPEN_COMPLETE, CLOSE_DROPDOWN } from "./constants";

export const openDropdown = name => ({ type: OPEN_DROPDOWN, name: name });

export const openComplete = name => ({ type: OPEN_COMPLETE, name: name });

export const closeDropdown = name => ({ type: CLOSE_DROPDOWN, name: name });



// WEBPACK FOOTER //
// ./template/state/modules/dropdown/actions.js